import * as toastr from 'toastr';

export function handleErrorResponse(response) {
    if (response.status === 405) {
        toastr.error('Onvoldoende rechten!');
    }
    throw new Error('error code: ' + response.status);
}

export function defaultHeaders() {
    return {
        'cache-control': 'no-cache',
        pragma: 'no-cache',
    };
}
